module.exports = "<ng-template #navbarHeaderLeftActionsTemplate>\n    <ng-content></ng-content>\n</ng-template>"